import { z } from 'zod';
import { beginLogout, completeLogout, getSession } from './session.store';
import { ApiError } from '../http/errors';

const CsrfSchema = z.object({ csrf: z.string().min(1) });

export async function revokeBrowserSession(baseUrl: string): Promise<void> {
  let csrf = getSession().csrf;
  beginLogout();
  const signal = AbortSignal.timeout(30_000);
  try {
    if (csrf === null) {
      const protection = await fetch(`${baseUrl}/auth/csrf`, {
        credentials: 'include', headers: { Accept: 'application/json' }, signal,
      });
      if (protection.status === 401) { completeLogout(); return; }
      if (!protection.ok) throw new Error('Falha ao recuperar a proteção da sessão.');
      csrf = CsrfSchema.parse(await protection.json()).csrf;
    }
    const response = await fetch(`${baseUrl}/auth/logout`, {
      method: 'POST', credentials: 'include', signal,
      headers: { Accept: 'application/json', 'X-CSRF-Token': csrf },
    });
    if (!response.ok && response.status !== 401) throw new Error('Falha ao revogar a sessão.');
    completeLogout();
  } catch {
    throw new ApiError({ status: 0, correlationId: undefined, kind: 'network',
      message: 'O acesso neste dispositivo foi bloqueado, mas não foi possível encerrar a sessão no servidor. Tente sair novamente.',
    });
  }
}
